import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {OfflineNetworkApiService} from '../network/offline-network-api.service';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {VoipPeerFilterService} from '../../../../../network/utils/filters/voip-peers/voip-peer-filter.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineVoipPeerApiService {

  constructor(private http: HttpClient,
              private offlineNetworkApiService: OfflineNetworkApiService) {}


  readonly offlineVoipPeerUrl = 'planning/voippeer';

  public getVoipPeersForMap(params: any = {}): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map(mapData => {
      const voipPeers = OfflineNetworkApiService.objectToArray(mapData.voipPeers);

      return this.filterVoipPeers(voipPeers, params);
    })).toPromise();
  }

  public getVoipPeerForMap(id: number): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map(mapData => {
      return mapData.voipPeers[id];
    })).toPromise();
  }

  public getVoipPeers(params: any = {}): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.offlineVoipPeerUrl, {filter: params});
    return this.http.get(url).toPromise();
  }

  public getVoipPeer(id: number): Promise<any> {
    return this.http.get(`${this.offlineVoipPeerUrl}/${id}`).toPromise();
  }

  public moveVoipPeers(voipPeers): Promise<any> {
    const url = `${this.offlineVoipPeerUrl}/location`;
    return this.http.put(url, voipPeers).toPromise();
  }

  public addVoipPeer(voipPeer: any): Promise<any> {
    return this.http.post(this.offlineVoipPeerUrl, voipPeer).toPromise();
  }

  public editVoipPeer(voipPeer: any, id: number): Promise<any> {
    const url = `${this.offlineVoipPeerUrl}/${id}`;
    return this.http.put(url, voipPeer).toPromise();
  }

  public deleteVoipPeer(id): Promise<any> {
    const url = `${this.offlineVoipPeerUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  private filterVoipPeers(voipPeers, params): void {
    return (params && params.mapFilter) ?
      VoipPeerFilterService.mapFilter(voipPeers, params.searchObject) : voipPeers;
  }
}
